import React from "react";
import { clsx } from "clsx";
import { Eyebrow } from "@bloomberg/media-ui-article";

import { Story } from "~types/types";
import {
    getEyebrowLink,
    getEyebrowSublink,
    getOpinionSuffix,
} from "~utils/eyebrowUtil";
import isOpinion from "~utils/isOpinion";

import styles from "./SectionIdentifier.module.css";

export type SectionIdentifierComponentProps = {
    story: Story;
    className: string;
};

export default function SectionIdentifier({
    className,
    story,
}: SectionIdentifierComponentProps) {
    const { cobrand, type } = story;

    const { text, path } = getEyebrowLink(story);
    const { text: subtext, path: subpath } = getEyebrowSublink(story);

    return (
        <Eyebrow
            className={clsx(className, {
                [styles.cobrand]: Boolean(cobrand),
            })}
            storyType={type}
            sectionTitle={text}
            sectionTitleLink={path}
            cobrand={cobrand}
            isOpinion={isOpinion(story)}
            opinionStoryType={getOpinionSuffix(story)}
            subsectionTitle={subtext}
            subsectionTitleLink={subpath}
            version="v2"
        />
    );
}
